export default {
  primary: '#0096ff',
  secondary: '#ffae00',
  tertiary: '#003680',
  quaternary: '#eeeeee',
  error: '#FF4500',
};
